import { useEffect, useState } from 'react';

const PAGE_SIZE = 10;

export const useCapTableGroupReveal = (totalCount: number, isExpanded: boolean) => {
  const [visibleCount, setVisibleCount] = useState(PAGE_SIZE);
  const [renderedCount, setRenderedCount] = useState(PAGE_SIZE);

  useEffect(() => {
    if (!isExpanded) {
      setVisibleCount(PAGE_SIZE);
      setRenderedCount(PAGE_SIZE);
    }
  }, [isExpanded]);

  const hiddenCount = Math.max(0, totalCount - visibleCount);
  const showRevealControl = totalCount > PAGE_SIZE;
  const isCollapsing = visibleCount < renderedCount;
  const showLess = (showRevealControl && hiddenCount === 0) || isCollapsing;
  const loadCount = Math.min(PAGE_SIZE, hiddenCount);

  const handleLoadMore = () => {
    const nextCount = visibleCount + Math.min(PAGE_SIZE, totalCount - visibleCount);
    setVisibleCount(nextCount);
    setRenderedCount(nextCount);
  };

  const handleShowLess = () => {
    if (visibleCount <= PAGE_SIZE) return;
    setVisibleCount(PAGE_SIZE);
  };

  const handleExtraCollapseComplete = () => {
    setRenderedCount((count) => (count === PAGE_SIZE ? count : PAGE_SIZE));
  };

  return {
    handleExtraCollapseComplete,
    handleLoadMore,
    handleShowLess,
    isExtraRowsOpen: visibleCount > PAGE_SIZE,
    loadCount,
    pinnedRowCount: PAGE_SIZE,
    renderedCount,
    showLess,
    showRevealControl,
  };
};
